import React from "react";
import { connect } from 'react-redux'
import { fetchCustomerMyPages, fetchCustomerPayer } from '../../api/customers/actions'
import { fetchTilbodMultiCustomer } from "../../api/offers/actions";
import { fetchPaymentApplications } from '../../api/payment-applications/actions'
import { fetchElectronicSigningRecords } from '../../api/signing-records/actions'
import { fetchQuestionnairesMyPages } from '../../api/questionnaires/actions'
import { fetchTooltips } from "../../api/tooltips/actions";
import MyPagesTabs from '../../components/my-pages-tab'
import { EmptyMyPages } from "../../utils";


class MyPages extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: 'contracts',
        }

        this.setActiveTab = this.setActiveTab.bind(this)
    }

    componentDidMount() {
        if (!window.isIE()) {
            let customer = this.props.customer.split('-').pop(); 
            // customer = '1407842309'
            // customer = '2908822229'
            this.props.dispatch(fetchCustomerMyPages(customer));
            // removed with json services migration
            // this.props.dispatch(fetchOlderDeclarations(customer));
            this.props.dispatch(fetchCustomerPayer(customer))
            this.props.dispatch(fetchPaymentApplications(customer));
            this.props.dispatch(fetchElectronicSigningRecords(customer));
            this.props.dispatch(fetchQuestionnairesMyPages());
            this.props.dispatch(fetchTooltips())
            this.props.dispatch(fetchTilbodMultiCustomer())

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.signingRecords && this.props.signingRecords.data && JSON.stringify(prevProps.signingRecords.data) !== JSON.stringify(this.props.signingRecords.data)) {
            if (this.props.signingRecords.data.Customer && this.props.signingRecords.data.Customer.ElectronicSignatureList && this.props.signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature) {
                this.setActiveTab('signings')
            }
        }
    }

    setActiveTab(tab) {
        this.setState({activeTab: tab})
    }

    render() {
        let customerId = this.props.customer.split('-').pop(); 
        // customerId = '1407842309'
        // customerId = '2908822229'

        let customers = this.props.customers;
        let customerPayers = this.props.customerPayers;
        let contracts = this.props.contracts;
        let olderDeclarations = this.props.olderDeclarations;
        let paymentApplications = this.props.paymentApplications;
        let signingRecords = this.props.signingRecords;
        let customerOffers = this.props.customerOffers;
        let additionalAxDocuments = this.props.additionalAxDocuments;

        if (window.isIE()) {
            return (<>
                <div className="page-error">
                    <div className="container justify-content-center text-center">
                        <div className="heading col-12 col-sm-8 mx-auto">
                            <h1>Úpps!</h1>
                            <h2>Við styðjum því miður ekki Internet Explorer. Vinsamlegast notaðu Edge, Chrome, eða Firefox.</h2>
                        </div>
                        <div className="img-container">
                            <img className="img-fluid" src={window.images.iceCream}/>
                        </div>
                        <a className="link mx-auto" href="/">Til baka á forsíðu</a>
                    </div>
                </div> 
            </>)
        }

        if (customers && !customers.isFetching && customerPayers && !customerPayers.isFetching ) {
            if ((this.props.customers.errorMessage === "" && customers.customerList.length > 0 && customers.customerList[0].Contracts.Contract.length > 0) || (this.props.customerPayers.errorMessage === "" && customerPayers.customerList.length > 0 && customerPayers.customerList[0].Contracts.Contract.length > 0 )) {
                return (
                    <>
                        <div className="tab-content w-100 step" id="pills-tabContent">

                            { <MyPagesTabs activeTab={this.state.activeTab} setActiveTab={this.setActiveTab} customerOffers={customerOffers} customerId={customerId} customers={customers} signingRecords={signingRecords} paymentApplications={paymentApplications} customerPayers={customerPayers} contracts={contracts} olderDeclarations={olderDeclarations} tooltips={this.props.tooltips} dispatch={this.props.dispatch} questionnaires={this.props.questionnaires} additionalAxDocuments={additionalAxDocuments}/>}

                        </div>
                    </>)
            } else {
                return <EmptyMyPages />
            }
        } else {
            return (<></>)
        }
    }
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        customerPayers: {},
        contracts: {},
        olderDeclarations: {},
        paymentApplications: {},
        signingRecords: {},
        customerOffers: {},
        tooltips: {},
        questionnaires: {},
        additionalAxDocuments: {}
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.customerPayers = (state.customerPayers === undefined) ? {} : state.customerPayers
    f.contracts = (state.contracts === undefined) ? {} : state.contracts
    f.olderDeclarations = (state.olderDeclarations === undefined) ? {} : state.olderDeclarations
    f.paymentApplications = (state.paymentApplications === undefined) ? {} : state.paymentApplications
    f.signingRecords = (state.signingRecords === undefined) ? {} : state.signingRecords
    f.customerOffers = (state.customerOffers === undefined) ? {} : state.customerOffers
    f.tooltips = (state.tooltips === undefined) ? {} : state.tooltips
    f.questionnaires = (state.questionnaires === undefined) ? {} : state.questionnaires
    f.additionalAxDocuments = (state.additionalAxDocuments === undefined) ? {} : state.additionalAxDocuments
    return f;
}

export default connect(mapStateToProps)(MyPages);
